import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=0b32b6df&scoped=true&"
import script from "./preview.vue?vue&type=script&lang=ts&"
export * from "./preview.vue?vue&type=script&lang=ts&"
import style0 from "./preview.vue?vue&type=style&index=0&id=0b32b6df&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b32b6df",
  null
  
)

export default component.exports